import React, { useEffect, useState } from 'react'
import { Link, NavLink, withRouter } from 'react-router-dom'
import { Badge, Row, Col, Spin, Avatar, Popover, message } from 'antd'
import { toggleLogoToHome } from '../../../redux/investorFlowControl/investorFlowControlActions'
import './HeaderStartupApproved.scss'
import logo from '../../../assets/images/LogoExitFund.svg'
import deviceLogo from '../../../assets/images/tracking/logo.png'
import { Container, Nav, Navbar } from 'react-bootstrap'
import Bell from '../../../assets/images/tracking/bell.svg'
import NoNotification from '../../../assets/images/approvedStartup/emtyNotificationIcon.svg'
import ProfileToggle from '../../../pages/StartupApprovedPortal/StartupApprovedProfile/ProfileToggle'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchStatus,
  fetchUnreadNotificationCount,
  fetchUnreadNotifications,
  clearAllNotification,
  triggerErrorMessageDisplay,
} from '../../../redux/startupApprovedFlowControl/StratupApprovedFlowControlActions'
import { fetchProfileData } from '../../../redux/trackingFlowControl/TrackingFlowControlActions'
import moment from 'moment'

const HeaderStartupApproved = props => {
  const currentPath = props.location.pathname.split('/')[props.location.pathname.split('/').length - 1]
  const nextPath = props.location.pathname.split('/')[props.location.pathname.split('/').length - 2]
  const {
    unread_notification_count,
    unread_notifications,
    notificationLoader,
    get_status_data,
  } = useSelector(state => state.StratupApprovedFlowControlReducers)
  const [logoutLoader, setLogoutLoader] = useState(false)
  const { profile_data } = useSelector(state => state.trackingFlowControlReducer)
  const dispatch = useDispatch()
  const [unread, setUnread] = useState(0)
  const fundraiseTab = ['invite-investors', 'invite-history', 'posts', 'post-all', 'view-history']

  // Fetch status of the startup users on specific paths
  useEffect(() => {
    if (currentPath == 'status' && !localStorage.getItem('tour_is_taken')) {
      dispatch(fetchStatus())
    }
  }, [])

  useEffect(() => {
    if (Object.keys(profile_data).length == 0) {
      dispatch(fetchProfileData())
    }
  }, [])

  useEffect(() => {
    dispatch(fetchUnreadNotificationCount())
  }, [])

  // Update unread count when unread_notification_count changes
  useEffect(() => {
    setUnread(unread_notification_count)
  }, [unread_notification_count])

  // Handle visibility change
  const VisibleChangeHandler = visiblity => {
    if (!visiblity) {
      setUnread(0)
    }
  }

  // Handle notification click & fetch unread notifications
  const onNotificationClick = () => {
    dispatch(fetchUnreadNotifications())
  }

  // Handle clear all notifications
  const onClearNotification = () => {
    dispatch(clearAllNotification())
  }

  // Component for notifications toggel
  const notifications = (
    <div
      className={`approved-notifications-content-wrapper ${
        unread_notifications?.length === 0 || unread_notifications?.data?.length == 0 ? 'no-data' : ''
      }`}
    >
      <>
        <div className="pop-header">
          <h4>Notification</h4>
          {!notificationLoader && (!unread_notifications || unread_notifications?.data?.length > 0) ? (
            <span className="clear-all" onClick={() => onClearNotification()}>
              Clear all
            </span>
          ) : (
            <span
              className="view-all"
              onClick={() => {
                setUnread(0)
                props.history.push('/startup/approve/notifications')
              }}
            >
              View All
            </span>
          )}
        </div>
        {notificationLoader ? (
          <div className="pop-content-empty">
            <Spin />
          </div>
        ) : unread_notifications?.data?.length > 0 ? (
          <>
            <div className="pop-content">
              {unread_notifications?.data?.map(item => (
                <div className="line-hr">
                  <Row gutter={12}>
                    <Col span={24}>
                      <div className="alignments-mian-wrap">
                        <div className="alignments">
                          <Avatar src={item?.profile_pic}>
                            {item?.first_name?.[0]?.toUpperCase() || 'A'}
                          </Avatar>
                        </div>
                        <div className="alignments">
                          <span className="notification-msg">{item?.activity}</span>
                          <span className="timing">{moment.utc(item?.timestamp).local().fromNow()}</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
            <div className="pop-footer">
              <span
                onClick={() => {
                  setUnread(0)
                  props.history.push('/startup/approve/notifications')
                }}
              >
                View All
              </span>
            </div>
          </>
        ) : (
          <div className="pop-content-empty">
            <img src={NoNotification} alt="" />
            <span className="no-notification-text">No new notifications</span>
          </div>
        )}
      </>
    </div>
  )
  const showErrorMessage = () => {
    dispatch(triggerErrorMessageDisplay(true))
  }

  return (
    <>
      {logoutLoader && (
        <div
          style={{
            position: 'absolute',
            zIndex: 1200,
            display: 'flex',
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 1,
            background: 'white',
          }}
        >
          <Spin />
        </div>
      )}

      <div className="startup-approved-header">
        <div className=" toolbar sticky-top w-100">
          <div
          //  className={props.isFeePageActive && 'disableNavbar'}
          />
          <div className="header m-0">
            <Navbar expand="lg" className="w-100 ">
              <Container className="headerTop" fluid>
                <Navbar.Brand className="left">
                  <NavLink
                    // onClick={toggleLogoToHome}
                    onClick={e => {
                      if (!get_status_data?.data?.fee_accepted && !profile_data?.data?.fee_accepted) {
                        e.preventDefault()
                        showErrorMessage()
                      } else {
                        toggleLogoToHome()
                      }
                    }}
                    style={{ textDecoration: 'none' }}
                    to="/startup/approve/dashboard/status"
                  >
                    <div className="" id="home-logo">
                      <img
                        src={logo}
                        className="desktop-logo"
                        alt="logo"
                        style={{ height: 'auto', width: '171px' }}
                      />
                      <img
                        src={deviceLogo}
                        className="mobile-logo"
                        alt="logo"
                        style={{ height: '45px', width: 'auto' }}
                      />
                    </div>
                  </NavLink>
                </Navbar.Brand>
                <Navbar id="basic-navbar-nav" className="d-none d-md-block justify-content-center">
                  <Nav className="d-flex justify-content-center">
                    <Nav
                      className={`text-dark px-2 navbar-list ${
                        (currentPath === 'status' || currentPath === 'q&a-forum') &&
                        get_status_data?.data?.fee_accepted
                          ? 'active'
                          : ''
                      }`}
                    >
                      <Link
                        to="/startup/approve/dashboard/status"
                        onClick={e => {
                          if (!get_status_data?.data?.fee_accepted && !profile_data?.data?.fee_accepted) {
                            e.preventDefault()
                            showErrorMessage()
                          }
                        }}
                      >
                        Dashboard
                      </Link>
                    </Nav>
                    <Nav
                      className={`text-dark px-2 navbar-list  ${
                        fundraiseTab?.includes(currentPath) ? 'active' : ''
                      }`}
                    >
                      {
                        // profile_data?.data?.public_link &&
                        get_status_data?.data?.fund_transfer_status == 'incomplete' ? (
                          <Link
                            onClick={e => {
                              if (!get_status_data?.data?.fee_accepted && !profile_data?.data?.fee_accepted) {
                                e.preventDefault()
                                showErrorMessage()
                              }
                            }}
                            to={'/startup/approve/fundraise/posts'}
                          >
                            Fundraise
                          </Link>
                        ) : (
                          <Link
                            onClick={e => {
                              if (!get_status_data?.data?.fee_accepted && !profile_data?.data?.fee_accepted) {
                                e.preventDefault()
                                showErrorMessage()
                              }
                            }}
                            to={props.isFeePageActive ? '' : '/startup/approve/fundraise/invite-history'}
                          >
                            Fundraise
                          </Link>
                        )
                      }
                    </Nav>
                    <Nav
                      className={`text-dark px-2 navbar-list ${
                        currentPath === 'monthly-updates' ||
                        nextPath === 'edit-monthly-update' ||
                        currentPath === 'analytics'
                          ? 'active'
                          : ''
                      }`}
                    >
                      <Link
                        onClick={e => {
                          if (!get_status_data?.data?.fee_accepted && !profile_data?.data?.fee_accepted) {
                            e.preventDefault()
                            showErrorMessage()
                          }
                        }}
                        to="/startup/approve/monthly-updates"
                      >
                        Monthly Updates
                      </Link>
                    </Nav>
                    <Nav
                      className={`text-dark px-2 navbar-list ${
                        currentPath === 'investors-history' || currentPath === 'investors-feedback'
                          ? 'active'
                          : ''
                      }`}
                    >
                      <Link
                        onClick={e => {
                          if (!get_status_data?.data?.fee_accepted && !profile_data?.data?.fee_accepted) {
                            e.preventDefault()
                            showErrorMessage()
                          }
                        }}
                        to="/startup/approve/investors/investors-history"
                      >
                        Investors
                      </Link>
                    </Nav>
                  </Nav>
                </Navbar>
                <div className="d-flex align-items-center profile-notification-wrap">
                  <div style={{ position: 'relative' }}>
                    <Popover
                      arrowContent={null}
                      content={notifications}
                      placement="bottomRight"
                      trigger={'click'}
                      overlayClassName="approved-notifications-content-wrapper-desktop"
                      overlayStyle={{ position: 'fixed' }}
                      onVisibleChange={visiblity => VisibleChangeHandler(visiblity)}
                      align={{
                        offset: [14, 4],
                      }}
                    >
                      <Badge
                        count={unread}
                        onClick={e => {
                          onNotificationClick()
                        }}
                        className="icon-pointer mr-3"
                      >
                        <img src={Bell} alt="" />
                      </Badge>
                    </Popover>
                  </div>
                  <ProfileToggle
                    get_status_data={get_status_data}
                    showErrorMessage={showErrorMessage}
                    setLogoutLoader={setLogoutLoader}
                  />
                </div>
              </Container>
            </Navbar>
          </div>
        </div>
      </div>
    </>
  )
}

export default withRouter(HeaderStartupApproved)
